import { Button as ChakraButton, ButtonProps } from "@chakra-ui/react";
import Link from "components/Link";

interface Props extends ButtonProps {
  href?: string;
  children: React.ReactNode;
}

const Button = ({ href, children, ...otherProps }: Props) => (
  <ChakraButton {...otherProps}>
    {href ? (
      <Link href={href} textStyle="buttonText" textDecoration="none !important">
        {children}
      </Link>
    ) : (
      children
    )}
  </ChakraButton>
);

export default Button;
